<template>
  <card shadow>
    <template #header>
      <div class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-md-6 pb-3 pb-md-0 text-start">
            <h5 class="mb-0 float-start">{{ userRole === "employee" ? $t("My Profile") : $t("Employee Details") }}</h5>
<!--            <span v-if="userRole === 'employee'" class="badge float-start ms-3" :class="{'bg-gradient-green': $store.state.user.claims?.email_verified, 'bg-danger': !$store.state.user.claims?.email_verified}" >{{ $store.state.user.claims?.email_verified ? $t('Email verified') : $t("Email not verified") }}</span>-->
          </div>
          <div v-if="['system', 'employee'].includes(userRole)" class="col-md-6 text-end">
            <div class="btn-group" role="group" aria-label="">
              <base-button type="secondary" size="sm" @click="changeEmail()">{{ $t("Change email") }}</base-button>
              <base-button type="secondary" size="sm" @click="changePhoneNumber()">{{ $t("Change phone number") }}</base-button>

              <router-link class="btn btn-sm btn-primary fw-bold" :to="$store.state.user.claims.role === 'employee' ? '/profile/edit' : '/employees/'+$route.params.id+'/edit'">
                {{ $t("Edit") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div>
      <div class="fw-bolder text-uppercase text-muted mt-4 text-start">{{ normalizeGreek(userRole === "employee" ? $t("Personal Details") : $t("Employee Details")) }}</div>
      <hr class="m-0">
      <div class="pl-lg-4 text-start">
        <div class="row">
          <div class="col-md-6 pt-2">
            <display-label
                label="First name"
                :value="employeeData.firstName"
            ></display-label>
          </div>
          <div class="col-md-6 pt-2">
            <display-label
                label="Last name"
                :value="employeeData.lastName"
            ></display-label>
          </div>
          <div class="col-md-6 pt-2">
            <display-label
                label="Type"
                :value="$t(employeeData.type ?? '')"
            ></display-label>
          </div>
<!--          <div class="col-md-6 pt-2">-->
<!--            <display-label-->
<!--                label="Gender"-->
<!--                :value="$t(employeeData.gender ?? '')"-->
<!--            ></display-label>-->
<!--          </div>-->
          <div class="col-md-6 pt-2">
            <div class="form-group has-label">
              <label class="form-label fw-bold m-0" aria-label="Identity card number">{{ $t("Identity card number") }}</label>
              <div class="text-black-50">
                {{ employeeData.identityCardNumber }}

                <a v-if="docRefs.hasOwnProperty('identity-front')" class="btn btn-sm" target="_blank" :href="docRefs['identity-front']"><i class="fa fa-download"></i>
                  {{ docRefs.hasOwnProperty('identity-back') ? $t('Front') : '' }}
                </a>
                <a v-if="docRefs.hasOwnProperty('identity-back')" class="btn btn-sm" target="_blank" :href="docRefs['identity-back']"><i class="fa fa-download"> </i>
                  {{ $t("Back") }}</a>
</div>
            </div>
          </div>
          <div class="col-md-6 pt-2">
            <div class="form-group has-label">
              <label class="form-label fw-bold m-0" aria-label="Registration number">{{ $t("Registration number") }}</label>
              <div class="text-black-50">
                {{ employeeData.registrationNumber }}
                <a v-if="docRefs.hasOwnProperty('registration')" class="btn btn-sm" target="_blank" :href="docRefs['registration']"><i class="fa fa-download"></i></a>
              </div>
            </div>
          </div>
          <div v-if="docRefs.hasOwnProperty('registry')" class="col-md-6 pt-2">
            <label class="form-label fw-bold m-0" aria-label="Registration number">{{ $t("registry") }}</label>
            <div class="text-black-50">
              <a class="btn btn-sm" target="_blank" :href="docRefs['registry']"><i class="fa fa-download"></i></a>
            </div>
          </div>

          <div v-if="userRole !== 'client'" class="col-md-6">
            <display-label
                label="Preferred language"
                :value="$t(employeeData.hasOwnProperty('contactLanguage') && employeeData.contactLanguage != null ? employeeData.contactLanguage : '')"
            ></display-label>
          </div>
          <div v-if="userRole !== 'client'" class="col-md-6 pt-2">
            <display-label
                label="Created at:"
                :value="employeeData.createdAt"
            ></display-label>
          </div>
        </div>
      </div>
      <hr class="m-0">
      <div class="pl-lg-4 text-start">
        <div class="row">
          <div class="col-md-6 pt-2">
            <display-label
                label="Contact email:"
                :value="employeeData.email"
            ></display-label>
          </div>
          <div class="col-md-6">
            <display-label
                label="Contact Phone:"
                :value="employeeData.phoneNumber"
            ></display-label>
          </div>
        </div>
      </div>

<!--      <div class="pl-lg-4 text-start">-->
<!--        <div class="fw-bolder text-uppercase text-muted mt-4 text-start mt-4">Billing Address</div>-->
<!--        <hr class="m-0">-->
<!--        <div class="row">-->
<!--          <div class="col-md-6 pt-2">-->
<!--            <display-label-->
<!--                label="Street:"-->
<!--                :value="employeeData.hasOwnProperty('address') ? employeeData.address.street : ''"-->
<!--            ></display-label>-->
<!--          </div>-->
<!--          <div class="col-md-6 pt-2">-->
<!--            <display-label-->
<!--                label="Street line 2:"-->
<!--                :value="employeeData.hasOwnProperty('address') ? employeeData.address.street2 : ''"-->
<!--            ></display-label>-->
<!--          </div>-->
<!--          <div class="col-md-4 pt-2">-->
<!--            <display-label-->
<!--                label="City:"-->
<!--                :value="employeeData.hasOwnProperty('address') ? employeeData.address.city : ''"-->
<!--            ></display-label>-->
<!--          </div>-->
<!--          <div class="col-md-4 pt-2">-->
<!--            <display-label-->
<!--                label="Country:"-->
<!--                :value="employeeData.hasOwnProperty('address') ? employeeData.address.countryCode : ''"-->
<!--            ></display-label>-->
<!--          </div>-->
<!--          <div class="col-md-4 pt-2">-->
<!--            <display-label-->
<!--                label="Post code:"-->
<!--                :value="employeeData.hasOwnProperty('address') ? employeeData.address.postalCode : ''"-->
<!--            ></display-label>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </card>
<!--  <card shadow  class="mt-3">-->
<!--    <template #header>-->
<!--      <div class="bg-white border-0">-->
<!--        <div class="row align-items-center">-->
<!--          <div class="col-8 text-start">-->
<!--            <h5 class=" mb-0">{{ $t("Address") }}</h5>-->
<!--          </div>-->
<!--          <div class="col-4 text-end">-->
<!--&lt;!&ndash;            <a class="h5" target="_blank" :href="'https://www.google.com/maps/search/?api=1&query='+addressText">&ndash;&gt;-->
<!--&lt;!&ndash;              <i class="fa fa-map-location"></i>&ndash;&gt;-->
<!--&lt;!&ndash;            </a>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </template>-->
<!--&lt;!&ndash;    <client-address :client-data="employeeData"></client-address>&ndash;&gt;-->
<!--  </card>-->
  <update-auth v-model:modal-auth-update="updateAuth" v-model:auth-value="updateAuthValue" @on-close="onCloseAuthUpdate"></update-auth>
</template>
<script>
import DisplayLabel from "@/components/DisplayLabel"
import {getDownloadURL, getStorage, ref} from "firebase/storage"
import Card from "@/components/Card.vue"
import ClientAddress from "@/views/Cards/ClientAddressCard.vue"
import UpdateAuth from "@/components/UpdateAuth.vue"
import BaseButton from "@/components/BaseButton.vue"
import {normalizeGreek} from "@/helpers/common"
export default {
  name: "employee-details-card",
  components: {BaseButton, UpdateAuth, Card, DisplayLabel},
  props: {
    employeeData: {
      type: Object,
      description: "Employee data",
    },
  },
emits: ["fetchEmployee"],
  data() {
    return {
      updateAuth: "",
      updateAuthValue: "",
      docRefs: [],
      isDisabled: true,
      alertMessage: "",
      loadingProcess: "",
      model: {
        address: {
          street: "",
          countryCode: "",
          city: "",
          lat: 0,
          long: 0 ,
          postalCode: "",
          street2: "",
        }
      },
    }
  },
  computed: {
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    },
  },
  watch: {
    employeeData(newVal) {
      this.model = newVal
    },
  },
  mounted() {
    console.log(this.$route.params)
    console.log("employeeData", this.employeeData)

    if (this.userRole === "client"){
      this.getDocReferences()
    }
  },
  methods: {
    normalizeGreek,
    onCloseAuthUpdate(updated){
      if (updated){
        this.$emit("fetchEmployee")
      }
      this.updateAuthValue = ""
      this.updateAuth = ""
    },
    changeEmail(){
      this.updateAuthValue = this.employeeData.email
      this.updateAuth = "email"
    },
    changePhoneNumber(){
      this.updateAuthValue = this.employeeData.phoneNumber
      this.updateAuth = "phoneNumber"
    },
    async getDocReferences() {
      const docs = ["identity-front", "identity-back", "registration", "registry"]
      for (let i = 0; i < docs.length; i++) {
        const name = docs[i]
        try {
          console.log("nameee", name)
          this.docRefs[name] = await this.downloadDoc(name)
        } catch (error) {
          console.error(name, error)
        }
      }
    },
    async downloadDoc(name) {
      const storage = getStorage()
      const idPathReference = ref(storage, "employees/" + this.employeeData.id + "/" + name)
      return await getDownloadURL(idPathReference)
    },
  },
}
</script>
<style></style>
